export const MERCEDES_EVA_CLAIM = 'MERCEDES_EVA-CLAIM';
